import { useMutation } from "@tanstack/react-query";
import { makeCRMApi } from "../CrmApi";
import { IBulkChangeNotificationsStatusRequest } from "../types/NotificationTypes";

export const useBulkNotificationsMarkViewed = () => {
  const crmApi = makeCRMApi();
  
  const bulkNotificationsMarkViewedMutation = useMutation({
    mutationKey: ['crm-bulk-mark-notifications-viewed'],
    mutationFn: (data: IBulkChangeNotificationsStatusRequest) => crmApi.bulkMarkNotificationsViewed(data),
  });
  
  return bulkNotificationsMarkViewedMutation;
}
